import React from "react";
import Border from "../Border";
import Collapsible from "react-collapsible";
import ColorPicker from "../ColorPicker";

export default function FormColors({ data, renderColor, updateSetting, props }) {
  const _renderColor = (colorKey, titleKey, defaultTitle, data) => {
    if (props[titleKey] === false) {
      return null;
    }

    return (
      <>
        <ColorPicker
          title={props[titleKey] || defaultTitle}
          color={data.settings[colorKey]}
          onColorSelected={(color) => {
            updateSetting(colorKey, color);
          }}
        />
        <br />
      </>
    );
  };

  return (
    <Border>
      <Collapsible trigger="Form Colours">
        <br />
        {_renderColor("quaternary_color", "quaternaryColorTitle", "Form Background Colour", data)}
        {_renderColor("form_text_color", "formTextColour", "Form Text Colour", data)}
        {_renderColor("form_fields_placeholder_color", "formFieldsPlaceholderColour", "Form Fields Placeholder Colour", data)}
        {_renderColor("form_fields_text_color", "formFieldsTextColour", "Form Fields Text Colour", data)}
        {_renderColor("quinary_color", "quinaryColorTitle", "Form Button Title Color", data)}
        {_renderColor("senary_color", "senaryColorTitle", "Form Button Background Color", data)}
      </Collapsible>
    </Border>
  );
}